import { objectTypes } from "src/consts/objectTypes.js";
import { ListInspections } from "src/components/ListInspections.js";
import { useState } from "react";
import { CalendarScreen } from "src/components/CalendarScreen";

export function ListEgenkontroller() {
  const [listType, setListType] = useState<"list" | "calendar">("list");
  return (
    <>
      {listType === "list" ? (
        <ListInspections objectType={objectTypes.Inspection} />
      ) : (
        <CalendarScreen objectType={objectTypes.Inspection} />
      )}
    </>
  );
}
